import * as React from "react";
import { Link, Typography, TypographyStack } from "@bolteu/kalep-react";
import { KALEP_ACTIONS_COLUMN_KEY } from "../constants";
import { cx } from "../utils/cx";
import { get } from "../utils/getNestedProp";
import { RowActions } from "./Row";
export function DefaultCellContent({ children, className, compact }) {
    return (React.createElement("div", { className: cx("w-full h-full grid items-center", "bolt-font-body-s-regular text-primary", compact ? "p-1" : "p-3 min-h-12 empty:min-h-0", className) }, children));
}
export function DataAndMeasuresCell({ data, measure, extraData, measurePosition = "after" }) {
    const inlineStyle = measurePosition === "before" ? { marginRight: "0.125rem" } : { marginLeft: "0.125rem" };
    const measureElement = (React.createElement(Typography, { inlineStyle: inlineStyle, inline: true, variant: "caption-secondary", color: "secondary" }, measure));
    const content = measurePosition === "before" ? (React.createElement(React.Fragment, null,
        measureElement,
        data)) : (React.createElement(React.Fragment, null,
        data,
        measureElement));
    return (React.createElement(DefaultCellContent, null,
        React.createElement(TypographyStack, { primary: content, secondary: extraData, primaryTypographyProps: {
                variant: "body-secondary",
            }, secondaryTypographyProps: {
                variant: "caption-secondary",
                color: "secondary",
            } })));
}
export function LinkCellContent({ href, target, children }) {
    return (React.createElement(DefaultCellContent, null,
        React.createElement(Link, { href: href, target: target, rel: "noreferrer" }, children)));
}
export function TextWithDescriptionCellContent({ compact, description, text }) {
    return (React.createElement(DefaultCellContent, { compact: compact, className: cx(compact ? "p-1" : "p-2 min-h-12 empty:min-h-0") },
        React.createElement(TypographyStack, { primary: text, secondary: description, primaryTypographyProps: { fontSize: "text-sm" }, secondaryTypographyProps: { fontSize: "text-xs" } })));
}
export function InternalCellContent({ columnKey, item, inlineActions, isRowClickable, compact, customRenderer, wrapRenderCellWithDefaultStyle, }) {
    var _a;
    if (columnKey === KALEP_ACTIONS_COLUMN_KEY && inlineActions) {
        return React.createElement(RowActions, { actions: inlineActions, row: item, compact: compact, isRowClickable: isRowClickable });
    }
    if (typeof customRenderer === "function") {
        return wrapRenderCellWithDefaultStyle ? (React.createElement(DefaultCellContent, { compact: compact }, customRenderer(item, columnKey))) : (React.createElement(React.Fragment, null, customRenderer(item, columnKey)));
    }
    let cellData = (_a = get(`${columnKey}`, item)) !== null && _a !== void 0 ? _a : "";
    if (typeof cellData !== "string") {
        cellData = JSON.stringify(cellData);
    }
    return React.createElement(DefaultCellContent, { compact: compact }, cellData);
}
